import { ExercisesImportResult } from './exercises-collection.models';

export const EXERCISE_FIELDS = {
  EXERCISE_NO: 'exerciseNo',
  EXERCISE_NAME: 'exerciseName',
  EXERCISE_DESCRIPTION: 'exerciseDescription',
  TECHNIQUE_CUES: 'techniqueCues',
  THUMBNAIL_URL: 'thumbnailUrl',
  VIDEO_LINK: 'videoLink',
  ACTIVATION: 'activation',
  BODY_REGION: 'bodyRegion',
  DIFFICULTY: 'difficulty',
  EQUIPMENT: 'equipment',
  FUNCTIONAL_FOCUS: 'functionalFocus',
  JOINTS: 'joints',
  IMPACT: 'impact',
  MOVEMENT_TYPE: 'movementType',
  MUSCLE_GROUPS: 'muscleGroups',
  IS_DELETED: 'isDeleted',
  DELETED_BY: 'deletedBy',
  DATE_TIME_DELETED: 'dateTimeDeleted',
  DATE_TIME_UPDATED: 'dateTimeUpdated',
} as const;

export const EXERCISE_IMPORT_RESULT_DEFAULT: ExercisesImportResult  = {
  success: [],
  failed: [],
  exceptionThrown: false,
  exception: null,
};
